/**
 * Tables with imported percentage widths (width="32%" on cells) can get pixel
 * widths baked into <colgroup> during a wide layout (e.g. fullscreen). Clearing
 * those inline styles lets the cell width attributes drive layout again.
 */
export function reflowImportedWidthTables(root: HTMLElement): void {
    root.querySelectorAll<HTMLTableElement>('[data-content-type="table"] table').forEach(table => {
        if (!table.querySelector('th[width$="%"], td[width$="%"]')) {
            return;
        }

        table.style.width = '100%';
        table.querySelectorAll('colgroup col').forEach(col => {
            col.setAttribute('width', '');
        });
    });
}
